import LegacyLayout from '../legacy-layout/legacy-layout';
import HeroLayout from '../layout/2022/layout';

const layoutEnums2022 = {
  '2021LP1': 'ms-2022',
  '2022MS': 'ms-2022',
  '2022LP1': 'lp1-2022',
  '2022LP2': 'lp2-2022',
};

export const getLayoutByYear = (year, { type, version }) => {
  switch (year) {
    case '2022': {
      return layoutEnums2022[type];
    }
    default: {
      const layout2021 = type === '2021LP1' ? 'lp1-2021' : 'lp2-2021';
      const layout = version ? layout2021 : 'lp-2020';
      return layout;
    }
  }
};

export const getLayoutByYearConfig = (componentDocument) => {
  switch (componentDocument?.props?.awardsYear) {
    case '2022':
      return [...HeroLayout.getEditingConfig(componentDocument)];
    default:
      return [...LegacyLayout.getEditingConfig(componentDocument)];
  }
};
